/*global Modernizr, console */
/*jslint browser:true */

(function() {
  'use strict';

  var search_modal_container = document.getElementById('dialog-search');

  if(search_modal_container) {
    search_modal_container.addEventListener('dialog-open', (e) => {
      setTimeout(function() {
        search_modal_container.querySelector('input').focus();
      }, 30);
    });
  }
}());